module.exports = __webpack_public_path__ + "static/img/newsimg3.cc0040c9.jpg";